import jsPDF from 'jspdf';

export function generateStoryPdf({ childName, mythology, title, body }) {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const margin = 56;
  const contentW = pageW - margin * 2;

  // Header
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(83, 74, 183);
  doc.text('TalesLore', margin, 60);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(120, 116, 140);
  doc.text('A personalized mythology bedtime story', pageW - margin, 60, { align: 'right' });

  // Divider
  doc.setDrawColor(220, 216, 240);
  doc.setLineWidth(0.5);
  doc.line(margin, 74, pageW - margin, 74);

  // Title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.setTextColor(26, 22, 37);
  const titleLines = doc.splitTextToSize(title, contentW);
  doc.text(titleLines, pageW / 2, 108, { align: 'center' });

  // Meta line
  const metaY = 108 + titleLines.length * 22 + 6;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(120, 116, 140);
  const dateStr = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  doc.text(`Created for ${childName} · ${mythology} mythology · ${dateStr}`, pageW / 2, metaY, { align: 'center' });

  // Divider 2
  doc.setDrawColor(220, 216, 240);
  doc.line(margin, metaY + 12, pageW - margin, metaY + 12);

  // Body
  doc.setFont('times', 'normal');
  doc.setFontSize(12);
  doc.setTextColor(30, 26, 44);
  const bodyY = metaY + 34;
  const paragraphs = body.split(/\n+/).filter((p) => p.trim());
  let y = bodyY;
  const lineHeight = 18;
  for (const p of paragraphs) {
    const lines = doc.splitTextToSize(p.trim(), contentW);
    for (const line of lines) {
      if (y > pageH - margin - 40) {
        doc.addPage();
        y = margin;
      }
      doc.text(line, margin, y);
      y += lineHeight;
    }
    y += 8;
  }

  // Footer
  const footerText = 'Created with love on TalesLore — taleslore.com';
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(150, 146, 170);
    doc.text(footerText, pageW / 2, pageH - 28, { align: 'center' });
  }

  const safeName = childName.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  const safeMyth = mythology.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  doc.save(`${safeName}-${safeMyth}-story-taleslore.pdf`);
}
